import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import './Roofing.scss';
import { useLocation, useNavigate } from "react-router-dom";
import Faq from "react-faq-component";
// images
import AreaData from './AreaData'
import LocationReviewsData from './LocationReviewsData'
import ReactCompareImage from "react-compare-image";
import BookAnAppointment from "../BookAnAppointment/BookAnAppointment";
import emailjs from 'emailjs-com';
import img22 from '../../Images/roof1b.png'
import img23 from '../../Images/roof2b.png'

export default function Roofing({ CitiePhone, locationsMain, CitiesData }) {

    const [Service, setService] = useState(true);
    const location = useLocation()
    const navigate = useNavigate()
    const [FormSubmiting, setFormSubmiting] = useState(false);
    const [response, setResponse] = useState({});
    const url = new URL(window.location.href);
    function sendEmail(e) {
        // setFormSubmiting(true)
        setFormSubmiting(true)
        e.preventDefault();    //This is important, i'm not sure why, but the email won't send without it

        emailjs.sendForm('service_fqud6um', 'template_vdkxpnd', e.target, 'QeqW-bXHRNjRmhZ6I')
            .then((result) => {
                setFormSubmiting(false)
                navigate(`/thankscontact?url=${location.pathname + location.search}`)
            }, (error) => {
                console.log(error.text);
            });
    }
    // Faqs
    const data = {
        title: "",
        rows: [
            {
                "title": "WHY CHOOSE AttiAir?",
                "content": "AttiAir stands out with years of expertise and a commitment to excellence. Our professional team uses state-of-the-art equipment and techniques to ensure your roof is repaired or replaced thoroughly, promoting a safer and more secure home. We pride ourselves on reliable service and customer satisfaction."
            },
            {
                "title": "WHAT SERVICES DO YOU OFFER?",
                "content": "We provide a wide range of services, including roof repair, roof replacement, roof installation, roof inspection, maintenance, gutter installation, and emergency roof services. Our goal is to ensure your roof performs efficiently and keeps your home protected."
            },
            {
                "title": "HOW MUCH DO YOUR SERVICES COST?",
                "content": "Our roof repair services start at just $99. Roof replacements are priced based on the size and materials of your roof. We also offer free consultations for any roof inspection or repair needs, ensuring you get a clear understanding of the work required before committing."
            },
            {
                "title": "CAN YOU REPAIR AND INSTALL A NEW ROOF AT THE SAME TIME?",
                "content": "Absolutely! AttiAir specializes in providing both roof repair and installation services. If you need a new roof, we can remove the old roofing and install the new one, ensuring a smooth and seamless process."
            },
            {
                "title": `DO YOU PROVIDE SERVICES SURROUNDING ${CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}?`,
                "content": `Yes, we proudly serve ${CitiesData && CitiesData.City ? CitiesData.City : "Your Area"} and the surrounding regions. Our service area extends to a 75-mile radius, ensuring that homes and businesses in nearby towns can benefit from our top-quality roofing services.`
            },
            {
                "title": "HOW DO I BOOK AN APPOINTMENT?",
                "content": `Booking with AttiAir is simple! Call us at <a href='tel:${CitiePhone}'>${CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.`
            },
            {
                "title": "HOW OFTEN SHOULD I HAVE MY ROOF INSPECTED?",
                "content": "We recommend having your roof inspected every 2 to 3 years, or more frequently if your area experiences heavy storms, hail, or extreme weather. Regular inspections help identify minor issues before they become major problems."
            },
            {
                "title": "WHY IS GUTTER INSTALLATION IMPORTANT?",
                "content": "Gutter installation helps direct water away from your roof and foundation, preventing leaks, mold growth, and water damage. Regular maintenance and the installation of gutter guards can prevent debris buildup and protect your home."
            }
        ]
    };

    const styles = {
        bgColor: '#f3f3f3',
        titleTextColor: '#222222',
        titleTextSize: '18px',
        rowTitleColor: '#222222',
        rowTitleTextSize: '19px',
        rowContentColor: '#242424',
        rowContentTextSize: '17px',
        // rowContentTextWeight: '600',
        rowContentPaddingTop: '10px',
        rowContentPaddingBottom: '10px',
        rowContentPaddingLeft: '5px',
        rowContentPaddingRight: '5px',
        arrowColor: "",
        //transitionDuration: "1s",
        // timingFunc: "ease"
    };
    const config = {
        // animate: true,
        // arrowIcon: "V",
        // tabFocus: true
        openOnload: 0,
    };

    useEffect(() => {
        (async () => {
            try {
                const searchKeyword = `I need from you 32 words about the "${url.searchParams.get('kd')}" how we "AttiAir" can help our clients with that kind of service, give me that as json file: title 3 words (include in the title words from the keyword, remove null and AttiAir from title)(if no keywords just do for roofing repair and replacement) and body`
                const apiKey = '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'; // Replace with your actual API key
                const resChat = await fetch(`https://api.openai.com/v1/chat/completions`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${apiKey}`,
                    },
                    body: JSON.stringify({
                        'model': 'gpt-3.5-turbo',
                        'messages': [
                            {
                                'role': 'user',
                                'content': searchKeyword
                            }
                        ]
                    })
                })
                const dataChat = await resChat.json()

                setResponse(JSON.parse(dataChat.choices[0].message.content))
            } catch (error) {
                console.log(error);
            }

            const getDerivedStateFromError = (error) => {
                console.log("123123");
                return { hasError: true };
            }
            const dsad = (error, errorInfo) => {
                console.log("123123");
            }
        })();
    }, []);
    return (
        <div className="Roofing" id="homepage">
<Helmet>
    {/* <!-- TITLE (Max 65 characters) --> */}
    <title>AttiAir - Roof Repair, Installation & Inspection | Residential & Commercial Roofing | 866-257-5796</title>

    {/* <!-- META TITLE (Max 35 characters) --> */}
    <meta name="title" property="title" content="AttiAir - Roof Repair, Installation & Inspection | Residential & Commercial Roofing | 866-257-5796" data-react-helmet="true" />
    <meta name="og:title" property="og:title" content="AttiAir - Roof Repair, Installation & Inspection | Residential & Commercial Roofing | 866-257-5796" data-react-helmet="true" />

    {/* <!-- META DETAILS --> */}
    <meta name="og:locale" property="og:locale" content="en_US" data-react-helmet="true" />
    <meta name="og:type" property="og:type" content="website" data-react-helmet="true" />
    <meta name="og:image" property="og:image" content="https://www.attiair.com/images/roofing-og.jpg" data-react-helmet="true" />
    <meta name="og:url" property="og:url" content="https://www.attiair.com/roofing-services" data-react-helmet="true" />

    {/* <!-- META DESCRIPTION (Max 155 characters, First Letter Uppercase) --> */}
    <meta 
        name="description" 
        content="AttiAir Provides Professional Roofing Services Including Repairs, Inspections, Replacements, And Leak Fixes For Homes And Businesses Across Southern California." 
        data-react-helmet="true" 
    />
    <meta 
        name="og:description" 
        property="og:description" 
        content="AttiAir Provides Professional Roofing Services Including Repairs, Inspections, Replacements, And Leak Fixes For Homes And Businesses Across Southern California." 
        data-react-helmet="true" 
    />

    <meta name="og:site_name" property="og:site_name" content="AttiAir" data-react-helmet="true" />

    {/* <!-- KEYWORDS --> */}
    <meta 
        name="keywords" 
        content="Roof Repair, Roof Installation, Roofing Inspection, Roof Replacement, Shingle Roofing, Tile Roofing, Flat Roof Repair, Commercial Roofing, Residential Roofing, Emergency Roof Repair, Roof Leak Fix, Roof Maintenance, Roofing Services Near Me, Local Roofing Contractor, AttiAir Roofing" 
        data-react-helmet="true" 
    />
</Helmet>

            {/* RoofingMainBanner */}
            <div className="RoofingMainBanner" >
                <div className="RoofingMainBannerTopLine">
                    <div className="RoofingMainBannerTopLineLine"></div>
                    <div className="RoofingMainBannerTopLineDot"></div>
                    <h1>ROOFING SERVICES</h1>
                </div>
                <div className="RoofingMainBannerTop">
                    <img src={require(`../../Images/rooofbanner.png`)} />
                    <img src={require(`../../ImagesLogos/Logo1.png`)} className="bannerlogohere" />
                    <div className="RoofingMainBannerTopLEFT"></div>

                </div>
                <div className="RoofingMainBannerBottom">
                    <div className="RoofingMainBannerBottomLeft">
                        <h1>The Roofing Experts You've Trusted for Over 20 Years In {CitiesData && CitiesData.City ? CitiesData.Full : "Your Area"}</h1>
                        <h2>Servicing <b>{CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : "Your Area"}</b> And Surrounding Areas • <span>{url.searchParams.get('kd') ? url.searchParams.get('kd').includes('near') ? url.searchParams.get('kd').replace('near me', '•') : url.searchParams.get('kd') + "," : ""}</span> Roof Replacement and Repair Near Me</h2>
                        <div className="RoofingMainBannerBottomLeftBtns">
                            <a target='_blank' href={`tel:${CitiePhone}`}>Call Us Now</a>
                            <a target='_blank' href={`tel:${CitiePhone}`}>{CitiePhone}</a>
                        </div>


                        <h4>LICENSED & INSURED ROOFING IN {CitiesData.City ? CitiesData.City.toUpperCase() : "YOUR AREA"}</h4>
                        <div className="RoofingMainBannerBottomLeftLine"></div>
                        <p>Reliable protection starts with a solid roof. Over time, your roof can experience wear and tear from weather conditions, leaks, and aging materials. Professional roofing repair and replacement services ensure that your roof is structurally sound, prevents leaks, and keeps your home safe from the elements. A well-maintained roof means peace of mind for you and your family, knowing your home is secure and protected.</p>
                        <p>Protect your home with a durable roof. Damaged shingles, leaks, and structural issues can compromise your home’s integrity and lead to costly repairs. Timely roof repair or replacement helps maintain your home’s safety, prevents further damage, and improves energy efficiency. Invest in roofing services to ensure long-lasting protection and comfort for your family.</p>
                        <div className="MainBannerLeftRatedMain">

                            <div className="Header2Location">
                                <img src={require(`../../Images/place.png`)} alt="" />
                                <h6>{CitiesData.City ? CitiesData.City.toUpperCase() : "Local"}</h6>

                            </div>
                            <div className="MainBannerLeftRated">
                                <h3>Rated 4.9 on Google</h3>
                                <span>
                                    <h4>4.9</h4>
                                    <img fetchpriority="low" src={require(`../../Images/Google.png`)} />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="RoofingMainBannerBottomRight">
                        <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
                        <img src={require(`../../Images/banner55.jpeg`)} />
                        <h3><img src={require(`../../Images/stars.png`)} alt="Locally Owned & Operated AttiAir Chimney Sweep Repair" />Locally Owned & Operated</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Licensed | Bonded | Insured AttiAir Chimney Sweep Repair" />Certified | Licensed | Insured</h3>
                        <h3><img src={require(`../../Images/stars.png`)} alt="Satisfaction Guaranteed AttiAir Chimney Sweep Repair" />Satisfaction Guaranteed</h3>

                    </div>
                </div>
            </div>
            {/* RoofingMainBannerService */}
            <div className="RoofingMainBannerService">
                <div className="RoofingMainBannerServiceMenu">
                    <div className="RoofingMainBannerServiceMenuBox" style={Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => true)}>
                        <h1>ROOF REPLACMENT</h1>
                    </div>
                    <div className="RoofingMainBannerServiceMenuBox" style={!Service ? { "backgroundColor": "white", "borderTop": "8px solid #fcb116" } : { "backgroundColor": "#e4e4e4", "borderTop": "8px solid #fcb116" }} onClick={() => setService(a => false)}>
                        <h1>ROOF REPAIR SERVICES</h1>
                    </div>
                </div>
                {Service ?
                    <div className="RoofingMainBannerServiceInfo">
                        <div className="RoofingMainBannerServiceInfoTop">
                            <div className="RoofingMainBannerServiceInfoLeft">
                                <h1>ROOF REPLACEMENT</h1>
                                <img src={require(`../../Images/roof1.png`)} />
                            </div>
                            <div className="RoofingMainBannerServiceInfoRight">
                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Roof Damage" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Leaking or Damaged Roof?</h2>
                                        <h3>Water leaks, cracked shingles, or damaged flashing can lead to serious structural issues. Our expert roof replacement service restores your home’s protection, ensuring a dry and secure space for you and your family.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Energy Efficiency" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>Old or damaged roofing materials can lead to poor insulation and energy inefficiency. A new roof improves your home’s energy efficiency, helping you save on heating and cooling costs while keeping your home comfortable year-round.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Weather Protection" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Concerned About Weather Damage?</h2>
                                        <h3>Your roof is your first line of defense against the elements. Our roof replacement service provides top-quality materials designed to withstand harsh weather conditions, including heavy rain, hail, and extreme temperatures.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="Curb Appeal" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Want to Boost Your Home’s Curb Appeal?</h2>
                                        <h3>A new roof can significantly enhance your home’s appearance. Whether you're selling your home or simply upgrading, a fresh roof adds value and improves your property’s aesthetic appeal.</h3>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR ROOFING SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Roof Cleaning" />
                                            <h3>Full Roof Replacement</h3>
                                            <h4>Replace Your Damaged or Aging Roof</h4>
                                            <h2>We offer complete roof replacement services for homes with damaged or aging roofs. We remove and dispose of old roofing materials and install new roofing systems, including asphalt shingles, metal, tile, and more.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Roof Inspection" />
                                            <h3>Old Roof Removal & Disposal</h3>
                                            <h4>Removing & Disposing of Old Roofing Materials</h4>
                                            <h2>We handle the removal and disposal of old roofing materials, including shingles, tiles, or metal, to make way for a new, secure roof system that offers superior protection and durability for your home.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Roof Maintenance" />
                                            <h3>Installing New Roofing Systems</h3>
                                            <h4>Installing New Roofing Systems</h4>
                                            <h2>We specialize in the installation of new roofing systems, including asphalt shingles, metal roofing, and tile. Choose the perfect option for your home to enhance curb appeal, protect from the elements, and increase energy efficiency.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Roof Repair" />
                                            <h3>Restore Your Roof</h3>
                                            <h4>Restoring Your Roof’s Functionality</h4>
                                            <h2>For roofs that are beyond repair, our full roof replacement services provide you with a brand-new roof that ensures your home is protected from leaks, weather, and the elements. Let us handle everything from removal to installation.</h2>
                                        </a>

                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    :
                    <div className="RoofingMainBannerServiceInfo">
                        <div className="RoofingMainBannerServiceInfoTop">
                            <div className="RoofingMainBannerServiceInfoLeft">
                                <h1>ROOF REPAIR SERVICES</h1>
                                <img src={require(`../../Images/roof2.png`)} />
                            </div>
                            <div className="RoofingMainBannerServiceInfoRight">
                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben2.png`)} alt="Leaky Roof" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Is Your Roof Leaking?</h2>
                                        <h3>A leaking roof can lead to serious damage inside your home. Our roof repair services quickly address leaks, preventing further damage and restoring your home’s protection.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben3.png`)} alt="Weather Damage" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Roof Damaged by Weather?</h2>
                                        <h3>Heavy storms, hail, or high winds can cause roof damage. Our roof repair experts can assess the damage and make necessary repairs to ensure your home is protected from the elements.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben1.png`)} alt="Cracked Shingles" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>Cracked or Missing Shingles?</h2>
                                        <h3>Cracked, curled, or missing shingles expose your roof to further damage. Our roof repair services replace damaged shingles, restoring the integrity of your roof and preventing leaks.</h3>
                                    </div>
                                </div>

                                <div className="RoofingBenefitsBox">
                                    <div className="RoofingBenefitsBoxImg">
                                        <img src={require(`../../Images/ben4.png`)} alt="High Energy Bills" />
                                    </div>
                                    <div className="RoofingBenefitsBoxBox">
                                        <h2>High Energy Bills?</h2>
                                        <h3>Damaged or poorly insulated roofs can lead to energy inefficiency. We repair your roof to improve insulation, reduce heat loss, and lower your energy bills.</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="BookAnAppointmentMainComponentEmergeryBox">
                            <a target='_blank' href={`tel:${CitiePhone}`}>For emergency service Call: <span>{CitiePhone}</span></a>
                        </div>
                        {/* MainBanner2Top2 */}
                        <div className="MainBanner2Top2" id="ourservices">
                            <div className="MainBanner2TopBox">
                                <div className="MainBanner2TopBoxBack">
                                    {/*  */}
                                </div>
                                <div className="MainBanner2TopBoxMain">
                                    <h2>OUR ROOF REPAIR SERVICES</h2>
                                    <div className="MainBanner2TopBoxMenu">
                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneycleaning.png`)} alt="Roof Leak Repair" />
                                            <h3>Roof Leak Repair</h3>
                                            <h4>Stop Leaks and Prevent Further Damage</h4>
                                            <h2>Our experts identify and fix roof leaks quickly, preventing water damage and ensuring your home stays dry and safe.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyinspection.png`)} alt="Roof Inspection" />
                                            <h3>Roof Inspection</h3>
                                            <h4>Catch Problems Early</h4>
                                            <h2>A thorough roof inspection allows us to identify small problems before they become major issues, saving you money on costly repairs.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneymaintenance.png`)} alt="Roof Maintenance" />
                                            <h3>Roof Maintenance</h3>
                                            <h4>Extend Your Roof’s Life</h4>
                                            <h2>Routine maintenance helps maintain the integrity of your roof, preventing wear and tear, and avoiding expensive repairs down the road.</h2>
                                        </a>

                                        <a className="MainBanner2TopBoxBox">
                                            <img src={require(`../../Images/chimneyrepair.png`)} alt="Roof Shingle Repair" />
                                            <h3>Roof Shingle Repair</h3>
                                            <h4>Replace Damaged or Missing Shingles</h4>
                                            <h2>We repair or replace damaged shingles to ensure your roof is fully protected from leaks, drafts, and weather damage.</h2>
                                        </a>
                                    </div>
                                    <div className="MainBanner2TopBoxMainChat">
                                        <img src={require(`../../ImagesLogos/Logo2.png`)} />
                                        <div className="MainBanner2TopBoxMainChatText">
                                            <h4>{response.title}</h4>
                                            <h3>{response.body}</h3>
                                            <h5>Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or fill out the <a href={`/book${location.search}`}>online form</a> to schedule your visit.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                }
                <h4>TAKE THE FIRST STEP TOWARD A HEALTHIER AND MORE <span>EFFICIENT HOME</span><br /> SCHEDULE YOUR ROOFING SERVICE TODAY!</h4>
                <div className="RoofingBenefitsbutn">
                    <a href={`tel:${CitiePhone}`}>{CitiePhone}<img src={require(`../../Images/telephone.png`)} /></a>
                    <a href='#book'>SCHEDULE <span>&nbsp;ONLINE</span><img src={require(`../../Images/book.png`)} alt="Air Duct Cleaning | Air Duct Repair | roofing services | Air Duct Inspection In Master," /></a>
                </div>
            </div>

            {/* RoofingGoodBY */}
            <div className="RoofingGoodBY">
                <h1>SAY GOODBYE TO LEAKY AND DAMAGED ROOFS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <h2>Experience a safer, more secure home with our professional roof repair and replacement services.</h2>

                <div className="RoofingGoodBYList">
                    <img src={require(`../../Images/110.jpg`)} />
                    <img src={require(`../../Images/111.jpg`)} />
                    <img src={require(`../../Images/112.jpg`)} />
                    <img src={require(`../../Images/113.jpg`)} />
                </div>
            </div>
            {/* Roofingbefore */}
            <div className="RoofingBefore">
                <div className="RoofingBeforeLeft">
                    <h1>THE IMPORTANCE OF A STRONG, SECURE ROOF</h1>
                    <h2>Protect Your Home, Save Money, and Improve Efficiency</h2>
                    <h3>Your roof is your home’s first line of defense against the elements. Over time, wear and tear, storm damage, or aging materials can lead to leaks, cracks, and other issues. These problems can compromise your home's integrity and energy efficiency. Regular roof inspections and repairs ensure that your roof remains strong, your home stays protected, and your energy costs stay low. Don’t wait until it’s too late—address roof issues early with professional repair and replacement services.</h3>
                    <h2>Why Roof Repair Matters</h2>
                    <h3>
                        ✔ <b>Enhanced Home Protection</b> – Prevent leaks and water damage that can affect your home’s structure.
                        <br />
                        ✔ <b>Improved Energy Efficiency</b> – A well-maintained roof helps maintain your home’s temperature, reducing heating and cooling costs.
                        <br />
                        ✔ <b>Increased Property Value</b> – A new roof boosts your home’s curb appeal and market value.
                        <br />
                        ✔ <b>Extended Roof Lifespan</b> – Regular roof maintenance prevents costly repairs and premature replacement.
                    </h3>
                    <h4>Booking with AttiAir is simple! Call us at <a href={`tel:${CitiePhone}`}>{CitiePhone}</a> or complete our <a href='#book'>online booking form</a>. Our team will confirm your appointment and be ready to assist you at your convenience.</h4>
                </div>

                <div className="RoofingBeforeBox">
                    <ReactCompareImage leftImage={img22} rightImage={img23} />
                </div>
            </div>
            {/* RoofingReviews */}
            <div className="RoofingReviews">
                <div className="RoofingReviewsHeader">
                    <h2>Our Reviews:</h2>
                    <h1>Customers are breathing the difference</h1>
                    <div className="RoofingReviewsHeaderLine"></div>
                </div>
                <div className="RoofingReviewsMenu">
                    {LocationReviewsData.map((A, index) =>
                        <div key={index} className="RoofingReviewsMenuBox">
                            <div className="RoofingReviewsMenuBoxStars">
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                                <img src={require(`../../Images/stars.png`)} />
                            </div>
                            <h1>{A.review}</h1>
                            <h2>{A.customer}</h2>
                        </div>
                    )}
                </div>
            </div>
            {/* RoofingBook */}
            <div className="RoofingBook" id="book">
                <div className="RoofingReviewsHeader">
                    <h2>Easy & Convenient Booking:</h2>
                    <h1>Schedule Your Service Online!</h1>
                    <div className="RoofingReviewsHeaderLine"></div>
                </div>
                <BookAnAppointment CitiesData={CitiesData} CitiePhone={CitiePhone} />
            </div>
            {/* MainBanner2Top2 */}
            <div className="RoofingServices">
                <div className="MainBanner2TopBoxMenu">
                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOF REPAIR SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofrepair.png`)} alt="Roof Repair" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Our roof repair services are designed to address any issues affecting your roof’s performance. Whether it's fixing leaks, cracks, or other forms of damage, we use industry-leading techniques to restore your roof’s integrity. Our team will inspect the damage, repair flashing, shingles, and tiles, and ensure that your roof can withstand harsh weather conditions. We provide prompt, reliable service, restoring your roof's strength and ensuring your home remains safe, dry, and secure from the elements.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Leak & Crack Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flashing & Shingle Fixes</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Storm Damage Repairs</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOF REPLACEMENT</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofreplacement.png`)} alt="Roof Replacement" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Our roof replacement service is perfect for homeowners with aging, damaged, or deteriorating roofs. We start by safely removing old roofing materials, including shingles, tiles, or metal, and disposing of them in an eco-friendly manner. Once cleared, we install a new, durable roofing system, whether it's asphalt shingles, metal, or tile, that will provide your home with enhanced protection and energy efficiency for years to come. Our skilled team ensures a smooth, hassle-free installation that will leave your home looking great and safeguarded against the elements.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Complete Roof Replacement</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Old Roof Removal & Disposal</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />New Roofing Systems (Asphalt, Metal, Tile)</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOF INSTALLATION</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roof2b.png`)} alt="Roof Installation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>We specialize in professional roof installations for both residential and commercial properties. Whether you're building a new home or upgrading an existing one, we offer a variety of roofing options to suit your needs. Our expert team installs durable materials such as asphalt shingles, metal roofing, or flat roofing systems, ensuring that your roof is properly structured and secure. We also install essential roof decking and underlayment, providing a solid foundation for your roof and enhancing its overall longevity and performance.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />New Roof Installations</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Shingle, Metal, & Flat Roofs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Decking & Underlayment Installation</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOF INSPECTION & MAINTENANCE</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofinstall.png`)} alt="Roof Inspection" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Routine roof inspections are critical to catching potential issues early, preventing major damage, and extending the lifespan of your roof. Our team conducts thorough inspections to assess your roof's condition, identifying areas in need of repair or maintenance. We also provide preventative maintenance services to keep your roof in optimal condition, such as cleaning gutters, resealing damaged areas, and reinforcing weakened spots. Regular inspections and maintenance help avoid costly repairs in the future and ensure your home remains well-protected year-round.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Routine Inspections</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Preventative Maintenance</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Minor Issue Identification</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>GUTTER INSTALLATION & REPAIR</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/gutter.png`)} alt="Gutter Installation" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>We provide comprehensive gutter installation and repair services, designed to protect your roof and foundation from water damage. Our team installs high-quality gutters and downspouts, ensuring effective water drainage away from your home. We also offer gutter cleaning and repair services, addressing issues such as clogs, leaks, or misalignment. In addition, we install gutter guards to prevent debris buildup, reducing the frequency of maintenance and extending the life of your gutter system.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />New Gutter & Downspout Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Gutter Guard Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Cleaning & Repairing Existing Gutters</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>ROOF COATING & WATERPROOFING</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofcoad.png`)} alt="Roof Coating & Waterproofing" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>Roof coatings and waterproofing solutions provide long-lasting protection for your roof, especially for flat roofs. We apply high-quality protective coatings that help reduce the effects of UV rays, harsh weather, and general wear and tear. Our waterproofing services are essential for preventing leaks and water damage, ensuring your roof remains watertight and secure, even during heavy rainfall or snow. These services significantly extend the lifespan of your roof and reduce the need for expensive repairs.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Protective Coatings</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Flat Roof Waterproofing</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />UV & Weather Protection</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>EMERGENCY ROOF SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofemergency.png`)} alt="Emergency Roof Services" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>In the event of a roofing emergency, we offer fast and reliable emergency roof services. Whether you need immediate tarping to protect against storm damage or urgent repairs for leaks, we’re here to help. Our team works quickly to address the situation and prevent further damage to your home, so you can have peace of mind knowing that your roof is secure and your home is protected.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Emergency Tarping</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Urgent Leak Repairs</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Temporary Roof Fixes</h2>
                            </div>
                        </div>
                    </a>

                    <a className="MainBanner2TopBoxBox">
                        <h3>VENTILATION SERVICES</h3>
                        <div className="MainBanner2TopBoxBoxvLine"></div>
                        <div className="MainBanner2TopBoxBoxBox">
                            <img className="MainBanner2TopBoxBoxBoxBoximg2" src={require(`../../Images/roofventn.png`)} alt="Ventilation Services" />
                            <div className="MainBanner2TopBoxBoxBox">
                                <h4>We install and repair attic ventilation systems to ensure proper airflow, reduce moisture buildup, and lower energy costs. Our ventilation solutions are designed to enhance the efficiency of your home’s heating and cooling system, prevent roof damage caused by excess heat and moisture, and help you save on energy bills. Proper attic ventilation helps your roof last longer and reduces the risk of mold and mildew growth.</h4>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Attic Ventilation Installation</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Moisture Control</h2>
                                <h2><img className="MainBanner2TopBoxBoxBoxBoximg" src={require(`../../Images/check.png`)} />Energy Cost Reduction</h2>
                            </div>
                        </div>
                    </a>
                </div>

            </div>

            {/* HomePageGoogleFAQ */}
            <div className="HomePageGoogleFAQ">
                <h1>ABOUT OUR {CitiesData && CitiesData.City ? CitiesData.City.toUpperCase() : ""} LOCATION</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="HomePageGoogleFAQTop">
                    <div className="HomePageGoogleFAQTopLeft">
                        <h2>PROUDLY SERVING OUR LOCAL COMMUNITY</h2>
                        <div className="HomePageGoogleFAQBorder"></div>
                        <h3>At AttiAir, we are dedicated to providing exceptional service to our community. For over 22 years, we have committed ourselves to delivering top-quality roof repair services over {CitiesData && CitiesData.City ? CitiesData.City : "your area"}, ensuring safer and more secure homes. In addition to roof repair, we also offer a range of services tailored to enhance the durability and efficiency of your roof, meeting the unique needs of our valued customers.</h3>
                        <div className="MainBannerLeftButtons">
                            <a href={`tel:${CitiePhone}`}>Call Us Now!<img fetchpriority="low" src={require(`../../Images/telephone.png`)} /></a>
                            <a href='#book'>SCHEDULE ONLINE<img src={require(`../../Images/book.png`)} alt="Chimney Sweep Cleaning Near Me AttiAir" /></a>
                        </div>
                    </div>
                    <div className="HomePageGoogleFAQTopRight">
                        <img src={require(`../../ImagesLogos/logobanner.png`)} />
                    </div>
                </div>
                <h1>FREQUENTLY ASKED QUESTIONS</h1>
                <div className="HomePageGoogleFAQBorder"></div>
                <div className="MainBanner4FaqMore">
                    <Faq
                        data={data}
                        styles={styles}
                        config={config}
                    />
                </div>
            </div>
        </div>
    )
}

